var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "63px",
    viewBox: "0 0 49 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B5EA0D56-8FD2-406B-8BA2-6D5CDD017040") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login/Singup/RAD",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.900000036
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login---Link--UI",
    transform: "translate(-936.000000, -198.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_envelope",
    transform: "translate(937.000000, 199.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(21.606796, 28.500000) scale(-1, 1) translate(-21.606796, -28.500000) translate(0.106796, 0.000000)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.16504854
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-5",
    points: "0.516671767 35.1609911 38.1741013 56.903117 38.1741013 24.1358646 0.516671767 2.39373791"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-6",
    points: "42.5905904 54.694106 42.5905904 21.929153 4.93546031 0.184724585"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.516671767,
    y1: 2.39381533,
    x2: 4.93569026,
    y2: 0.184267759,
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.1741013,
    y1: 24.1366311,
    x2: 42.5908203,
    y2: 21.929383,
    id: "Stroke-8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.1741013,
    y1: 56.9038835,
    x2: 42.5908203,
    y2: 54.6943359,
    id: "Stroke-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy",
    transform: "translate(27.101942, 32.742718) scale(-1, 1) translate(-27.101942, -32.742718) translate(7.601942, 5.242718)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    fill: "#78AA00",
    opacity: 0.6,
    transform: "translate(19.617887, 27.639676) scale(-1, 1) translate(-19.617887, -27.639676) ",
    points: "0.789172427 22.3245735 0.789172427 54.6968271 38.4466019 33.3497001 38.4466019 0.582524272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.960466835,1.63838592 L14.5494871,24.3478164 L18.5293095,30.9945482 C19.0094436,31.7045053 19.6852462,32.08679 20.1517292,31.9160937 L24.1452716,29.8658984 L37.7411903,22.8868952",
    id: "Stroke-3",
    stroke: "#000000",
    strokeWidth: 1.16504854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-5",
    stroke: "#000000",
    strokeWidth: 1.16504854,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0.516671767 32.830894 38.1741013 54.5730199 38.1741013 21.8057675 0.516671767 0.0636408257"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnvelope);
export default __webpack_public_path__ + "static/media/icon_envelope.9a29e9010721ba260a6cb9b6e2029bff.svg";
export { ForwardRef as ReactComponent };